import type React from "react";
import { useState } from "react";

import type { CallData, VideoCallMode } from "routes/videocall";

import { VideoCallContext } from "./VideoCallContext";

interface VideoCallContextProviderProps {
  children: React.ReactNode;
}

export const VideoCallContextProvider: React.FC<VideoCallContextProviderProps> = ({ children }) => {
  const [callData, setCallData] = useState<CallData | null>(null);
  const [videoCallMode, setVideoCallMode] = useState<VideoCallMode>("docked");

  const value = {
    callData,
    setCallData,
    videoCallMode,
    setVideoCallMode,
  };

  return <VideoCallContext.Provider value={value}>{children}</VideoCallContext.Provider>;
};
